export function parseCurrencySafe(currencyString) {
  let currencyParsed = Number.parseFloat(currencyString);
  if(isNaN(currencyParsed)) currencyParsed = 0;
  return currencyParsed;
}
